<template>

  <div class="active-basic">
    <div class="common-form">基本信息</div>

 
    <el-form-item label="名称" prop="title" :rules="[{ required: true, message: '请输入名称' }]">
      <el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input>
    </el-form-item>
 

  </div>
</template>

<script>
import Getpoint from '@/components/map/Getpoint.vue';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
export default {
  components: {
    Uediter,
    Upload,
    Getpoint,
    GetUser
  },
  data() {

    return {
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      open_add:false,

    };
  },
  props: ['form'],
  methods: {
    
    /*获取经纬度*/
    getMapdataFunc(e) {
      this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      this.form.latitude = e.data[0].toFixed(6);
      this.form.longitude = e.data[1].toFixed(6);
    },
    /*选择的地址*/
    choseFunc(e){
      this.form.coordinate=e.location.lat+','+e.location.lng;
      this.form.latitude = e.location.lat
      this.form.longitude = e.location.lng;
      this.form.address=e.address;

    },

    /*打开弹出层*/
    addClick() {
      console.log
      this.open_add = true;
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      if (e.type != 'error') {
        this.form.user = e.params[0];
        this.form.user_id = e.params[0].user_id;
      }
      this.open_add = false;
    },
  }
};
</script>

<style lang="scss">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/project/type/part/Basic.vue